import Image from 'next/image'
import Link from 'next/link'
import ChildImage from '../../../public/images/child.jpg'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
interface Props {
  age_group_options: any
}
export default function AgeGroups({age_group_options}: Props) {
  const {t} = useTranslation('common');
  const {locale} = useRouter();
  return (
    <div className="age-groups mt-24 container-fluid">
      <h1 className="text-success text-center font-bold text-3xl" dir={`${locale === 'ar' ? 'rtl': 'ltr'}`}>
        {t('ageGroupHeading')}
      </h1>
      <div className="age-groups-list mt-2 lg:grid lg:grid-cols-3  lg:gap-6">
        {age_group_options.map((age_group_opt: any) => {
          return (
            <div key={age_group_opt.id} className="age-group relative mt-4">
              <div className="age-group-text absolute w-full top-0 z-10 pt-6">
                <h2 className="text-success font-bold text-center text-xl">
                  {
                    (age_group_opt.name === 'من سن 0 الى 3 سنوات' && locale === 'ar') ? 'من سن 0 الى 3 سنوات' : 
                    (age_group_opt.name === 'من سن 0 الى 3 سنوات' && locale === 'en') ? "From Age 0 To 3 Years" : 
                    (age_group_opt.name === 'من سن 6 الى 3 سنوات' && locale === 'ar') ? 'من سن 6 الى 3 سنوات' : 
                    (age_group_opt.name === 'من سن 6 الى 3 سنوات' && locale === 'en') ? "From Age 3 To 6 Years" : 
                    (age_group_opt.name === 'من سن 6 سنوات وأكبر' && locale === 'ar') ? 'من سن 6 سنوات وأكبر' : 
                    (age_group_opt.name === 'من سن 6 سنوات وأكبر' && locale === 'en') ? "From Age 6 Years And Older" 
                    : age_group_opt.name
                  }
                </h2>
                <p className="text-white text-center mt-2">
                  {(locale === 'ar' ? age_group_opt?.description?.ar : age_group_opt?.description?.en) || ' '}
                </p>
              </div>
              <div className="image relative rounded-md">
                <div className="overlay-blue rounded-md"></div>
                <Image
                  src={
                    process.env.NEXT_PUBLIC_CDN_URL + '/' + age_group_opt.image
                  }
                  alt="Child"
                  width={500}
                  height={550}
                  className="w-full h-full rounded-md"
                />
              </div>
              <div className="absolute text-center bottom-6 left-0 right-0 max-w-[80%] mx-auto">
                <Link
                  href={'/products?options=' + age_group_opt.slug}
                  className="text-primary block py-3 bg-success rounded-md w-full font-semibold">
                  {t('viewBooks')}
                </Link>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
